// The rail's index space is NOT the page index: `step` addresses onboarding
// screens (OnboardCompany, Review) and stays 0..3 even when Owners is skipped.
export const ONBOARDING_STEP_KEYS = [
  "Business",
  "Authorization",
  "Owners",
  "ReviewAndSubmit",
];

const OWNERS_PAGE_INDEX = 2;

export interface OnboardingRail {
  stepKeys: string[];
  activeStep: number;
}

export function onboardingRail(
  step: number,
  ownersRequired: boolean,
): OnboardingRail {
  const stepKeys = ownersRequired
    ? ONBOARDING_STEP_KEYS
    : ONBOARDING_STEP_KEYS.filter((_key, index) => index !== OWNERS_PAGE_INDEX);

  // Owners is off the rail, so its own page index falls back to the step
  // before it rather than jumping ahead to Review.
  const railStep = ownersRequired || step < OWNERS_PAGE_INDEX ? step : step - 1;

  return {
    stepKeys,
    activeStep: Math.min(Math.max(railStep, 0), stepKeys.length - 1),
  };
}
